import React, { useEffect, useState } from 'react';
import { FormControlLabel, makeStyles, Switch, Tooltip } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
// import ImmersionModal from '../../../../../atoms/modals/commonModal';
import { getAllAnalysisModerated, removeGraphData, getExcludedParticipants, excludeParticipants, getAllAnalysisAsync, updateSettings, setFingerPulseToggle, setLoading, } from '../../../../../../store/actions/creator/analysis';
import _ from "underscore";
import UtilService from '../../../../../../helper/service';
import { Loading } from '../../../../../atoms/commonLoadings';
import constants from '../../../../../../config/constants';

const useStyles = makeStyles(() => ({
	root: {
		width: 230,
		zIndex: 1000
	},
	container: {
		width: 230,
		background: '#f0f0f0',
		zIndex: 1000,
		padding: '60px 8px 0 22px',
		height: '100%',
	},
	filterTitle: {
		fontFamily: 'roboto-bold',
		fontSize: 16,
		color: '#4F5F6E'
	},
	filterSubTitle: {
		fontFamily: 'roboto-bold',
		fontSize: '14px!important',
		color: '#697683',
		marginLeft: 10
	},
	participantsPanel: {
		marginTop: 30,
		display: 'flex',
		flexDirection: 'column'
	},
	switchBtn: {
		marginLeft: -5
	},
	icon: {
		borderRadius: 3,
		width: 27,
		height: 28,
		backgroundColor: '#f5f8fa',
		backgroundImage: "url(\"/assets/icons/unchecked.svg\")",
		marginRight: 10
	},
	checkedIcon: {
		marginRight: 10,
		'&:before': {
			display: 'block',
			width: 31.5,
			height: 28,
			backgroundImage: "url(\"/assets/icons/checked.svg\")",
			content: '""',
		},
	},
	checkbox: {
		'&:hover': {
			backgroundColor: 'transparent',
		},
	},
	switch: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center'
	},
	infoIcon: {
		width: 30,
		height: 30,
		cursor: 'pointer'
	},
	infoDiv: {
		width: 200,
		borderRadius: 20,
		backgroundColor: '#e4e4e4',
		padding: '15px 20px',
		fontSize: 14
	},
	infoTitle: {
		fontFamily: 'roboto-bold'
	},
	infoDescription: {
		marginTop: 4,
		fontFamily: 'roboto-regular'
	},
	btn: {
		height: 37,
		borderRadius: 6,
		background: '#0179EE',
		color: 'white',
		textTransform: 'none',
		fontSize: 14,
		fontFamily: 'roboto-regular',
		'&:hover': {
			background: '#0d77d4',
		},
	},
	switchPDF: {
		width: 24,
		height: 17,
		marginLeft: 6
	},
}));

const useStylesBootstrap = makeStyles(() => ({
	arrow: {
		color: '#6f6f6f'
	},
	tooltip: {
		maxWidth: 300,
		backgroundColor: '#6f6f6f',
		// fontSize: 12,
		// padding: 8
	},
}));

function BootstrapTooltip(props: any) {
	const classes = useStylesBootstrap();
	return <Tooltip arrow classes={classes} {...props} />;
}


interface IState {
	[key: string]: boolean
}

const tooltipText = 'We automatically removed this measurement because it looks as though something may have occurred with this participant during data collection. You may toggle this back on at any time to re-include the data and/or remove it again. To learn more, please reference our knowledge center.'

function AnalysisFilterRealPanel() {

	const classes = useStyles();
	const dispatch = useDispatch();
	const [state, setState] = useState<IState>();

	const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
	const apolloClient = useSelector((state: any) => state.apolloClient)
	const { start, sessionData } = useSelector((state: any) => state.creatorExperienceManager);
	const disable_fingerpulse = sessionData?.session?.disable_fingerpulse;

	// const [removeLoading, setRemoveLoading] = useState<boolean>(false);
	const [restoreLoading, setRestoreLoading] = useState<boolean>(false);

	const { analyseStart, analyseEnd, cliped } = useSelector((state: any) => state.analysis);
	const { identifiers, tags, towertags, currentSession, all, excludedParticipants, stimulus, loading, settings, attendedIdentifiers, excludedParticipantsReason, fingerpulse } = useSelector((state: any) => state.analysis);
	const [allTags, setallTags] = useState<any>([])
	const { session_type, session_code, session_status, started_at, ended_at, scheduled_start_at, scheduled_end_at, session_trim_from, session_trim_to } = currentSession;
	const stimulus_id = stimulus?.stimulus_id;
	const { pdfLoading } = settings;

	const analysed_start = Math.floor(started_at ? started_at : scheduled_start_at);
	const analysed_end = Math.floor(ended_at ? ended_at : scheduled_end_at);
	const videoLength = stimulus?.stimulus_video_length;
	const tenant_id = Number(loginUserData.customer_id);
	const [recommendTags, setRecommendTagsRole] = useState(false);
	const isFingerPulse = session_type === 'ASYNC' && !disable_fingerpulse

	const reasonIdentifierList = excludedParticipantsReason.map((item: any) => item.exclude_reason && item.identifier)

	useEffect(() => {

		if (loginUserData && loginUserData.role_access) {
			if (loginUserData.role_access.length) {
				const recommend_tags = loginUserData.role_access.find((val: any) => val.access_name === "recommend_tags");
				if (recommend_tags && recommend_tags.access_value) {
					setRecommendTagsRole(true)
				}
			}
		}
	}, [])

	useEffect(() => {
		if (!!towertags && towertags.length > 0 && recommendTags) {
			const alltag = tags.concat(towertags.filter((bo: any) => tags.every((ao: any) => ao.tagName !== bo.tagName)));
			setallTags(alltag)
		} else {
			setallTags(tags)
		}
	}, [towertags])

	// useEffect(() => {
	// 	if (!removeLoading && session_type === 'ASYNC') {
	// 		dispatch(getExcludedParticipants(apolloClient.client, session_code))
	// 	}
	// }, [removeLoading, identifiers])

	const onCallingAllModerated = async (_identifiers: string[], name: string, from_epoch: number, to_epoch: number, isTag: boolean) => {
		const request = {
			identifiers: (name === 'All') ? _.difference(identifiers, excludedParticipants) : [..._identifiers],
			from_epoch,
			to_epoch,
			session_started_at: session_trim_from ? Number(started_at) : analyseStart,
			session_completed_at: session_trim_to ? analysed_end : analyseEnd,
			tenant_id: Number(loginUserData.customer_id),
			session_code,
		};
		dispatch(await getAllAnalysisModerated(request, loginUserData.customer_id, session_code, name, session_status, name === 'All', true, isTag, false, cliped))
	};

	const onCallingAllAsync = async (ids: any, name: any, isTag: boolean) => {
		const request = {
			tenant_id: Number(loginUserData.customer_id),
			session_code,
			stimulus_id,
			session_started_at: analysed_start,
			session_completed_at: analysed_end,
			identifiers: (name === 'All') ? _.difference(identifiers, excludedParticipants) : [...ids],
			from_clip: UtilService.calcVideoEnd(0),
			to_clip: UtilService.calcVideoEnd(videoLength)
		};
		dispatch(await getAllAnalysisAsync(request, tenant_id, session_code, name, isTag, false, cliped))
	}

	const handleTagChange = (event: any) => {
		const tagIdentifiers = allTags.find((item: any) => item['tagName'] === event.target.name)['identifiers'];
		if (event.target.checked) {
			session_type === 'ASYNC'
				? onCallingAllAsync(_.difference(tagIdentifiers, excludedParticipants), event.target.name, true)
				: onCallingAllModerated(_.difference(tagIdentifiers, excludedParticipants), event.target.name, analyseStart, analyseEnd, true);
		} else {
			dispatch(removeGraphData(event.target.name));
		}
	};

	const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {

		// if (excludedParticipants.includes(event.target.name)) {
		// 	setRemovalCode(event.target.name);
		// 	setRemoveModal(true);
		// 	return false;
		// }

		if (event.target.checked && session_code) {
			session_type === 'ASYNC'
				? onCallingAllAsync(event.target.name === 'All' ? identifiers : [event.target.name], event.target.name, false)
				: (session_status === 'LIVE' && all.length > constants.ANALYZE.LIVE_MOD_LIMIT_GRAPH_COUNTS)
					? onCallingAllModerated([event.target.name], event.target.name, analyseStart, analyseEnd, false)
					: onCallingAllModerated([event.target.name], event.target.name, analyseStart, analyseEnd, false)

			if (event.target.name === 'All' && session_type === 'MODERATED' && session_status === 'LIVE') {
				dispatch(updateSettings('liveDisabledIdentifers', false))
			}

		} else {
			dispatch(removeGraphData(event.target.name));
			event.target.name === 'All' && dispatch(updateSettings('liveDisabledIdentifers', true))
		}
		setState({ ...state, [event.target.name]: event.target.checked });
	};

	const getSwitchValue = (key: string) => {
		const check = all.find((graphData: any) => graphData.activeParticipant === key);
		return !!check;
	};


	const onRestoreAll = async () => {
		dispatch(setLoading(true))
		setRestoreLoading(true);
		await Promise.all(excludedParticipants.map((code: string) => {
			const request = {
				session_code,
				exclude: false,
				identifier: [code]
			}

			dispatch(excludeParticipants(apolloClient.client, request, () => {
				dispatch(getExcludedParticipants(apolloClient.client, session_code))
			}))
		}))
		setRestoreLoading(false);
	}

	return (
		<div className={classes.root}>

			<div className={classes.container}>
				{(identifiers.length > 0) && (
					<>
						<div>

							<p className={classes.filterTitle}>Filters</p>
							<div className={classes.switch}>
								<FormControlLabel
									className={classes.switchBtn}
									classes={{
										label: classes.filterSubTitle,
									}}
									disabled={start}
									control={
										pdfLoading
											? <img src={`/assets/icons/switch_${getSwitchValue('All') ? 'on' : 'off'}.png`} alt='switch on' className={classes.switchPDF} />
											: <Switch
												checked={getSwitchValue('All')}
												size="small"
												onChange={handleChange}
												name="All"
												color="primary"
											/>
									}
									label="All Participants"
								/>

								{loading === 'all' && <Loading style={{ height: 30, width: 50, marginTop: -28, marginLeft: -10 }} />}
							</div>

							{isFingerPulse && <div className={classes.switch} style={{ marginTop: 10 }}>
								<FormControlLabel
									className={classes.switchBtn}
									classes={{
										label: classes.filterSubTitle,
									}}
									control={
										pdfLoading
											? <img src={`/assets/icons/switch_${fingerpulse ? 'on' : 'off'}.png`} alt='switch on' className={classes.switchPDF} />
											: <Switch
												checked={fingerpulse}
												size="small"
												onChange={(e) => dispatch(setFingerPulseToggle(e.target.checked))}
												name="All"
												color="primary"
											/>
									}
									label="Exclude Finger Pulse"
								/>
							</div>}

						</div>
						{allTags.length > 0 && (
							<div className={classes.participantsPanel}>
								<p className={classes.filterTitle}>Tags</p>
								{allTags.map((tag: any, index: number) => {

									const isDuplicatedList = _.intersection(attendedIdentifiers, tag.identifiers)
									if(isDuplicatedList.length === 0) return false

									return (
										<div className={classes.switch} key={index}>
											<FormControlLabel
												className={classes.switchBtn}
												style={{ marginBottom: 8 }}
												classes={{
													label: classes.filterSubTitle
												}}
												disabled={start}
												control={
													pdfLoading
														? <img src={`/assets/icons/switch_${getSwitchValue(tag['tagName']) ? 'on' : 'off'}.png`} alt='switch on' className={classes.switchPDF} />
														: <Switch
															checked={getSwitchValue(tag['tagName'])}
															size="small"
															onChange={handleTagChange}
															name={tag['tagName']}
															color="primary"
														/>
												}
												label={tag['tagName']}
											/>
											{loading === tag['tagName'] && <Loading style={{ height: 30, width: 50, marginTop: -28, marginLeft: -10 }} />}
										</div>
									)
								})
								}
							</div>
						)}
						<div className={classes.participantsPanel}>
							<p className={classes.filterTitle}>Participants</p>

							{attendedIdentifiers
								.sort(function (a: any, b: any) {
									if (!excludedParticipants.includes(a) && excludedParticipants.includes(b)) { return -1; }
									return 0;
								})
								.filter((code: string) => !excludedParticipants.includes(code))
								.map((code: string, index: number) => (
									<div className={classes.switch} key={index}>
										<FormControlLabel
											className={classes.switchBtn}
											style={{ marginBottom: 8, opacity: excludedParticipants.includes(code) ? 0.6 : 1 }}
											classes={{
												label: classes.filterSubTitle
											}}
											disabled={start}
											control={
												pdfLoading
													? <img src={`/assets/icons/switch_${getSwitchValue(code) ? 'on' : 'off'}.png`} alt='switch on' className={classes.switchPDF} />
													: <Switch
														checked={getSwitchValue(code)}
														size="small"
														onChange={handleChange}
														name={code}
														color="primary"
													/>
											}
											label={excludedParticipants.includes(code) ? `${code} REMOVED` : code}
										/>
										{loading === code && <Loading style={{ height: 30, width: 50, marginTop: -28, marginLeft: -10 }} />}
									</div>
								))
							}

							{excludedParticipants.length > 0 && <div
								className={classes.filterTitle}
								style={{ marginBottom: 10, color: '#017aef', width: 100, marginTop: 30, cursor: 'pointer' }}
							>
								<BootstrapTooltip title="Click to restore all excluded participants" arrow>
									<div onClick={onRestoreAll}>Restore All</div>
								</BootstrapTooltip>
								{restoreLoading && <Loading style={{ height: 30, width: 50, marginTop: -28, marginLeft: -10 }} />}
							</div>}

							{attendedIdentifiers
								.sort(function (a: any, b: any) {
									if (!excludedParticipants.includes(a) && excludedParticipants.includes(b)) { return -1; }
									return 0;
								})
								.filter((code: string) => excludedParticipants.includes(code))
								.map((code: string, index: number) => (
									<div className={classes.switch} key={index}>
										<BootstrapTooltip title={reasonIdentifierList.includes(code) ? tooltipText : ''} arrow placement="left">
											<FormControlLabel
												className={classes.switchBtn}
												style={{ marginBottom: 8, opacity: excludedParticipants.includes(code) ? 0.6 : 1 }}
												classes={{
													label: classes.filterSubTitle
												}}
												disabled={start}
												control={
													pdfLoading
														? <img src={`/assets/icons/switch_${getSwitchValue(code) ? 'on' : 'off'}.png`} alt='switch on' className={classes.switchPDF} />
														: <Switch
															checked={getSwitchValue(code)}
															size="small"
															onChange={handleChange}
															name={code}
															color="primary"
														/>
												}
												label={excludedParticipants.includes(code) ? `${code} REMOVED` : code}
											/>
										</BootstrapTooltip>
										{loading === code && <Loading style={{ height: 30, width: 50, marginTop: -28, marginLeft: -10 }} />}
									</div>
								))
							}
						</div>
					</>
				)}
				{identifiers.length === 0 && <p>No Participants</p>}

			</div>
		</div>

	)
}

export default AnalysisFilterRealPanel;